<template>
  <v-container>
    <v-row>
      <v-col> 
        <v-row align="start" class=" hidden-sm-and-down">
          <v-col cols="6">         
            <p class="text-h6 fontDarkGrey--text font-weight-bold">
              {{ user.base_package.package
                  ? user.base_package.package.name.EN
                  : ' אין חבילה' }}
            </p>
            <p class="text-capitalize text-h6 fontGrey--text text-right" dir="ltr">
              {{ user.base_package.package
                  ? user.base_package.package.description.EN
                  : '' }}
            </p>
          </v-col>
          <v-col>
            <p class="text-h6 fontGrey--text ">עלות:</p>
            <p class="text-h6 fontGrey--text font-weight-bold">
              {{ user.base_package.package
                  ? user.base_package.package.price
                  : '' }} ש״ח
            </p>
          </v-col>
          <v-col>        
            <p class="text-h6 fontGrey--text mb-0">המספרים שלי:</p>         
            <PhoneNumberSelect :displayFirst="user.main_cid"/>
          </v-col>
        </v-row>
        <UserPackageUsage :usage="user.base_package.package.usage" :activationStart="user.base_package.activation_start"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import PhoneNumberSelect from '@/components/CommonComponents/Selects/PhoneNumberSelect'

export default {
  name: "UserPackage",
  components: {
    PhoneNumberSelect,
    UserPackageUsage: () =>  import("@/components/User/Package/UserPackageUsage")
  },
  computed: {
    ...mapState({
        user: state => state.user.profile
    }),
  },
};
</script>
